export const leadCategories = [
  {
    id: 'hvac',
    name: 'HVAC Services',
    icon: 'ri-temp-cold-line',
    description: 'Heating, cooling, and air quality services',
    leadPrice: 75,
    avgResponseTime: '2 hours',
    providerCount: 45
  },
  {
    id: 'plumbing',
    name: 'Plumbing',
    icon: 'ri-drop-line',
    description: 'Repairs, installations, and emergency services',
    leadPrice: 60,
    avgResponseTime: '1 hour',
    providerCount: 52
  },
  {
    id: 'electrical',
    name: 'Electrical',
    icon: 'ri-flashlight-line',
    description: 'Wiring, repairs, and electrical installations',
    leadPrice: 65,
    avgResponseTime: '2 hours',
    providerCount: 38
  },
  {
    id: 'roofing',
    name: 'Roofing',
    icon: 'ri-home-4-line',
    description: 'Roof repairs, replacement, and inspections',
    leadPrice: 85,
    avgResponseTime: '3 hours',
    providerCount: 28
  },
  {
    id: 'solar',
    name: 'Solar Installation',
    icon: 'ri-sun-line',
    description: 'Solar panel installation and maintenance',
    leadPrice: 100,
    avgResponseTime: '4 hours',
    providerCount: 22
  },
  {
    id: 'landscaping',
    name: 'Landscaping',
    icon: 'ri-plant-line',
    description: 'Lawn care, design, and maintenance',
    leadPrice: 35,
    avgResponseTime: '3 hours',
    providerCount: 65
  },
  {
    id: 'painting',
    name: 'Painting',
    icon: 'ri-paint-brush-line',
    description: 'Interior and exterior painting services',
    leadPrice: 40,
    avgResponseTime: '2 hours',
    providerCount: 48
  },
  {
    id: 'cleaning',
    name: 'House Cleaning',
    icon: 'ri-brush-line',
    description: 'Residential and commercial cleaning',
    leadPrice: 20,
    avgResponseTime: '1 hour',
    providerCount: 72
  },
  {
    id: 'handyman',
    name: 'Handyman',
    icon: 'ri-tools-line',
    description: 'General repairs and home improvements',
    leadPrice: 25,
    avgResponseTime: '2 hours',
    providerCount: 58
  },
  {
    id: 'pest-control',
    name: 'Pest Control',
    icon: 'ri-bug-line',
    description: 'Pest inspection and extermination',
    leadPrice: 45,
    avgResponseTime: '3 hours',
    providerCount: 32
  },
  {
    id: 'legal',
    name: 'Legal Services',
    icon: 'ri-scales-3-line',
    description: 'Attorneys and legal consultation',
    leadPrice: 50,
    avgResponseTime: '4 hours',
    providerCount: 42
  },
  {
    id: 'accounting',
    name: 'Accounting',
    icon: 'ri-calculator-line',
    description: 'Tax preparation and bookkeeping',
    leadPrice: 40,
    avgResponseTime: '5 hours',
    providerCount: 35
  },
  {
    id: 'real-estate',
    name: 'Real Estate',
    icon: 'ri-home-smile-line',
    description: 'Buying, selling, and property management',
    leadPrice: 45,
    avgResponseTime: '2 hours',
    providerCount: 68
  },
  {
    id: 'moving',
    name: 'Moving Services',
    icon: 'ri-truck-line',
    description: 'Local and long-distance moving',
    leadPrice: 35,
    avgResponseTime: '3 hours',
    providerCount: 28
  },
  {
    id: 'remodeling',
    name: 'Home Remodeling',
    icon: 'ri-hammer-line',
    description: 'Kitchen, bathroom, and home renovations',
    leadPrice: 80,
    avgResponseTime: '4 hours',
    providerCount: 34
  }
];

export const leadStats = {
  totalLeadsGenerated: 2547,
  activeProviders: 352,
  averageRating: 4.8,
  avgResponseTime: '24hrs'
};